import displayError from '@/api/errors/errorResponse'
import { generateFormInputService } from '@/api/services/advertisements/advertisementsService'
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage
} from '@/components/forms/form/Form'
import FormWrap from '@/components/forms/form/FormWrap'
import { Button } from '@/components/ui/common/Button'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger
} from '@/components/ui/dialog/Dialog'
import { useMutation } from '@tanstack/react-query'
import { useForm, UseFormSetValue } from 'react-hook-form'
import { FormSchema } from './generatorFormSchema'

import { Textarea } from '@/components/forms/inputs/text/Textarea'
import { zodResolver } from '@hookform/resolvers/zod'
import { useState } from 'react'
import { z } from 'zod'

const inputSchema = z.object({
  description: z.string().min(1, 'Opis jest wymagany')
})

type InputSchema = z.infer<typeof inputSchema>

function AutoInput({
  setValue,
  image
}: {
  setValue: UseFormSetValue<FormSchema>
  image: string
}) {
  const [open, setOpen] = useState(false)
  const form = useForm<InputSchema>({
    resolver: zodResolver(inputSchema),
    defaultValues: {
      description: ''
    }
  })

  const { mutate, isPending } = useMutation({
    mutationFn: (description: string) =>
      generateFormInputService({ description, productImageFileTmp: image }),
    onSuccess: (res) => {
      if (!res.success) return displayError(res)
      setValue('creationDescription', res.data.creationDescription)
      setValue('mainColors', res.data.mainColors)
      setValue('adSlogan', res.data.adSlogan)
      setValue('priceDescription', res.data.priceDescription)
      setOpen(false)
      form.reset()
    }
  })

  const onSubmit = (data: InputSchema) => {
    mutate(data.description)
  }

  return (
    <Dialog onOpenChange={setOpen} open={open}>
      <DialogTrigger asChild>
        <Button type="button">Generuj input przez AI</Button>
      </DialogTrigger>
      <DialogContent
        aria-describedby="Generowanie poprzez AI"
        aria-description="Generowanie poprzez AI"
      >
        <DialogHeader>
          <DialogTitle>Wygeneruj opis z pomocą AI</DialogTitle>
        </DialogHeader>
        <Form {...form}>
          <FormWrap onSubmit={form.handleSubmit(onSubmit)}>
            <FormField
              control={form.control}
              name="description"
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <Textarea
                      placeholder="Wpisz opis, aby wygnerować input..."
                      {...field}
                      // error={errors?.creationDescription}
                    />
                  </FormControl>
                  <FormMessage />
                  <span className="text-xs text-black/50 italic">
                    Dodając zdjęcie produktu, wynik będzie dokładniejszy.
                  </span>
                </FormItem>
              )}
            />
            <div className="mt-4 -mb-6 flex items-center justify-end">
              <Button disabled={isPending} type="submit">
                Generuj
              </Button>
            </div>
          </FormWrap>
        </Form>
      </DialogContent>
    </Dialog>
  )
}

export default AutoInput
